import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule, TypedBaseListComponent } from '@vendure/admin-ui/core';
import { DEFAULT_CHANNEL_CODE } from '@vendure/common/lib/shared-constants';
import {
  GetBaseProductVariantsDocument,
  SortOrder,
} from '../../../gql/graphql';

@Component({
  standalone: true,
  selector: 'base-product-selected',
  styleUrls: ['./base-product-selected.component.css'],
  templateUrl: './base-product-selected.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, CommonModule],
})
export class BaseProductSelectedComponent
  extends TypedBaseListComponent<
    typeof GetBaseProductVariantsDocument,
    'baseProductVariants'
  >
  implements OnInit
{
  @Input() id: string;

  constructor() {
    super();
    super.configure({
      document: GetBaseProductVariantsDocument,
      getItems: data => data.baseProductVariants,
      setVariables: (skip, take) => ({
        id: this.id ?? '',
        options: {
          sort: {
            updatedAt: SortOrder.DESC,
          },
          skip,
          take,
        },
      }),
      refreshListOnChanges: [],
    });
  }

  getSeller(
    channels: {
      id: string;
      code: string;
      seller: {
        id: string;
        name: string;
      };
    }[],
  ) {
    return channels.filter(e => e.code !== DEFAULT_CHANNEL_CODE)[0];
  }
}
